<div class="card">

  <div class="card-header">
    {{ 'CUSTOMER_RECORD_OWNER_GROUPS' | translate }}
    <div class="card-actions">
      <a class="btn-setting table-header-action-button d-flex align-items-center px-1 w-auto font-weight-normal"
         (click)="ownerUserGroupAddClicked()"
         *ngIf="!readonly && rightModel.customerRecordChangeOwner.hasRight()"
         title="{{'CUSTOMER_RECORD_ADD_OWNER_GROUP' | translate}}">
        <i class="icomoon pr-1 icomoon-add"></i>{{ 'CUSTOMER_RECORD_ADD_OWNER_GROUP' | translate }}
      </a>
    </div><!-- /.card-actions -->
  </div>

  <div class="card-body">
    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="UserGroup.OrderField.ID"
                                  [orderType]="queryModel.getOrderType(UserGroup.OrderField.ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="UserGroup.OrderField.NAME"
                                  [orderType]="queryModel.getOrderType(UserGroup.OrderField.NAME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_NAME' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op></app-table-sorter-no-op>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let group of groupList | paginate: {
                                                      id: pagingId,
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }"
          [disabledTableRow]="group.disabled">
        <td class="fit">{{ group.id }}</td>
        <td class="responsive-table-column long">
          <a class="id-text cursor-pointer"
             href="#" onclick="return false"
             uiSref="Admin.UserGroupDetail"
             *ngIf="rightModel.webMenuAdmin.hasRight() && rightModel.webAdminUserGroups.hasRight(); else simpleName"
             [uiParams]="{id: group.id}"
             title="{{'COMMON_BUTTON_DETAILS' | translate}}">
            {{ group.name }}
          </a>
          <ng-template #simpleName>{{ group.name }}</ng-template>
        </td>
        <td class="align-middle">
          <app-table-options-menu>
            <app-dropdown-item
              [iconClass]="'icomoon-detail'"
              [titleStringKey]="'COMMON_BUTTON_DETAILS'"
              class="cursor-pointer"
              uiSref="Admin.UserGroupDetail"
              *ngIf="rightModel.webMenuAdmin.hasRight() && rightModel.webAdminUserGroups.hasRight()"
              [uiParams]="{id: group.id}">
            </app-dropdown-item>
            <app-dropdown-item
              *ngIf="!readonly && rightModel.customerRecordChangeOwner.hasRight()"
              [iconClass]="'icomoon-trash'"
              [titleStringKey]="'COMMON_BUTTON_REMOVE'"
              class="cursor-pointer"
              (click)="groupDeleteClicked(group)">
            </app-dropdown-item>
          </app-table-options-menu>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="UserGroup.OrderField.ID"
                                  [orderType]="queryModel.getOrderType(UserGroup.OrderField.ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="UserGroup.OrderField.NAME"
                                  [orderType]="queryModel.getOrderType(UserGroup.OrderField.NAME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_NAME' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op></app-table-sorter-no-op>
        </th>
      </tr>
      </tfoot>
    </table>
    <app-table-paging
      [id]="pagingId"
      [currentNumberOfItems]="queryModel.currentNumberOfItems"
      [totalNumberOfItems]="queryModel.totalNumberOfItems"
      [itemsPerPage]="queryModel.itemsPerPage"
      (pageChange)="pageChanged($event)"
      (itemsPerPageChange)="itemsPerPageChanged($event)">
    </app-table-paging>
  </div>
</div>
